import React, { useState } from 'react'
import { IEnterprisePlaylistTalentCard } from './interface'
import useStyle from './Styles'
import Env from '../../config/constants/env'
import { get } from 'lodash'
import { Box, Button } from '@material-ui/core'
import { TalentInitiativesDialog } from 'components'

const EnterprisePlaylistTalentCard: React.FC<IEnterprisePlaylistTalentCard> = ({
  talentId,
  firstName,
  lastName,
  avatar,
  currentRole,
  currentCompany,
  school,
  selfTags,
  initiatives
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const classes = useStyle({})

  const fullName = `${firstName} ${lastName}`

  const schoolInfo = `${school?.description} | ${school?.fieldOfStudy} | ${school?.degreeType}`

  const jobInfo = `${currentRole} at ${currentCompany}`

  const sortedTags = selfTags.sort((a, b) => {
    const aLength = get(a, 'value.length')
    const bLength = get(b, 'value.length')

    if (bLength > aLength) {
      return -1
    }
    if (aLength > bLength) {
      return 1
    }
    return 0
  })

  const openDialog = (event: any) => {
    event.stopPropagation()
    setIsDialogOpen(true)
  }

  const closeDialog = () => {
    setIsDialogOpen(false)
  }

  const navigateToProfile = () => {
    window.open(`${Env.SITE.WEBAPP_URL}/profile/${talentId}`)
  }

  return (
    <Box>
      <a className={classes.card} onClick={navigateToProfile} rel="noopener noreferrer">
        <Box display="flex" alignItems="center" mr={3}>
          <div className={classes.avatar}>
            <img id={`${firstName}-${lastName}-avatar`} src={avatar} alt="" />
          </div>
        </Box>
        <Box flexDirection="colum">
          <Box>
            <span id={`${firstName}-${lastName}-full-name`} className={classes.talentName}>
              {fullName}
            </span>
          </Box>
          {school?.description && (
            <Box>
              <span id={`${firstName}-${lastName}-school-info`} className={classes.talentData}>
                {schoolInfo}
              </span>
            </Box>
          )}
          {currentCompany && (
            <Box>
              <span id={`${firstName}-${lastName}-job-info`} className={classes.talentData}>
                {jobInfo}
              </span>
            </Box>
          )}
        </Box>
        <div className={classes.tagContainer}>
          {sortedTags.map(tag => (
            <div className={classes.tag} key={tag._id}>
              <span id={`${firstName}-${lastName}-${tag._id}-tag`} className={classes.tagValue}>
                {tag.value}
              </span>
            </div>
          ))}
          {initiatives?.length > 0 && (
            <Box className={classes.initiativeQuestionsContainer}>
              <Button
                id={`${firstName}-${lastName}-view-initiative-questions-button`}
                variant="contained"
                className={classes.initiativeQuestionsBtn}
                onClick={openDialog}
              >
                View initiative questions
              </Button>
            </Box>
          )}
        </div>
      </a>
      <TalentInitiativesDialog initiatives={initiatives} isOpen={isDialogOpen} onClose={closeDialog} />
    </Box>
  )
}

export default EnterprisePlaylistTalentCard
